import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "modal_merchant_order_list",
  ref: "merchantOrderList",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-1000px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  class: "modal-header",
  id: "kt_modal_merchant_order_list_header"
}
const _hoisted_5 = { class: "w-100 d-flex align-items-center justify-content-between flex-max-sm-column max-sm-align-items-start" }
const _hoisted_6 = { class: "max-sm-w-100 d-flex align-items-center justify-content-between" }
const _hoisted_7 = { class: "fw-bolder" }
const _hoisted_8 = { class: "fs-6 text-gray-400" }
const _hoisted_9 = { class: "d-none max-sm-block max-sm-align-self-start" }
const _hoisted_10 = {
  "data-bs-dismiss": "modal",
  class: "btn btn-icon btn-sm btn-active-icon-primary"
}
const _hoisted_11 = { class: "svg-icon svg-icon-1" }
const _hoisted_12 = {
  class: "d-flex align-items-center justify-content-end gap-4 pe-20 max-sm-pe-0",
  "data-kt-customer-table-toolbar": "base"
}
const _hoisted_13 = {
  "data-bs-dismiss": "modal",
  class: "btn btn-icon btn-sm btn-active-icon-primary max-sm-align-self-start max-sm-hidden"
}
const _hoisted_14 = { class: "svg-icon svg-icon-1" }
const _hoisted_15 = { class: "card" }
const _hoisted_16 = { class: "card-body" }
const _hoisted_17 = { class: "modal-body p-0" }
const _hoisted_18 = { class: "dataTables_wrapper dt-bootstrap4 no-footer" }
const _hoisted_19 = { class: "table-responsive" }
const _hoisted_20 = {
  class: "table align-middle table-hover fs-6 dataTable no-footer max-sm-text-nowrap",
  role: "grid"
}
const _hoisted_21 = { class: "fw-bold text-gray-800" }
const _hoisted_22 = { class: "border-0" }
const _hoisted_23 = { class: "text-start" }
const _hoisted_24 = { class: "d-flex" }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = ["onUpdate:modelValue", "disabled"]
const _hoisted_27 = {
  colspan: "6",
  class: "text-start"
}
const _hoisted_28 = { class: "d-flex flex-column justify-content-center" }
const _hoisted_29 = { class: "mb-1 text-line-clamp-1 fw-boldest" }
const _hoisted_30 = { class: "fs-7 text-gray-400" }
const _hoisted_31 = { class: "text-end" }
const _hoisted_32 = { class: "d-flex flex-column justify-content-center" }
const _hoisted_33 = { class: "mb-1" }
const _hoisted_34 = { class: "fs-7 text-danger" }
const _hoisted_35 = {
  key: 1,
  class: "fs-7 text-gray-400"
}
const _hoisted_36 = { class: "text-end" }
const _hoisted_37 = { class: "d-flex flex-column justify-content-center" }
const _hoisted_38 = { class: "mb-1" }
const _hoisted_39 = {
  key: 0,
  class: "m-0"
}
const _hoisted_40 = { class: "fs-7 text-danger text-nowrap" }
const _hoisted_41 = {
  key: 1,
  class: "fs-7 text-gray-400 text-nowrap"
}
const _hoisted_42 = { class: "text-end" }
const _hoisted_43 = ["onClick"]
const _hoisted_44 = { class: "svg-icon svg-icon-3 icon-plus" }
const _hoisted_45 = { class: "svg-icon svg-icon-3 icon-minus" }
const _hoisted_46 = { class: "text-start" }
const _hoisted_47 = { class: "d-flex" }
const _hoisted_48 = ["onClick"]
const _hoisted_49 = ["onUpdate:modelValue", "disabled"]
const _hoisted_50 = {
  colspan: "3",
  class: "text-start"
}
const _hoisted_51 = {
  colspan: "3",
  class: "text-start"
}
const _hoisted_52 = { class: "d-flex align-items-center" }
const _hoisted_53 = { class: "svg-icon svg-icon-4 svg-icon-gray-600 ms-1" }
const _hoisted_54 = { class: "text-end" }
const _hoisted_55 = { class: "d-flex flex-column justify-content-center" }
const _hoisted_56 = { class: "mb-1" }
const _hoisted_57 = { class: "d-flex justify-content-end align-items-center" }
const _hoisted_58 = ["innerHTML"]
const _hoisted_59 = { class: "svg-icon svg-icon-4 svg-icon-danger ms-2" }
const _hoisted_60 = { class: "svg-icon svg-icon-4 svg-icon-gray-600 ms-2" }
const _hoisted_61 = { class: "text-end" }
const _hoisted_62 = { class: "d-flex flex-column justify-content-center" }
const _hoisted_63 = { class: "mb-1" }
const _hoisted_64 = ["innerHTML"]
const _hoisted_65 = { class: "fs-7 text-danger text-nowrap" }
const _hoisted_66 = {
  key: 1,
  class: "fs-7 text-gray-400 text-nowrap"
}
const _hoisted_67 = /*#__PURE__*/_createElementVNode("td", { class: "text-end text-nowrap w-60px" }, null, -1)
const _hoisted_68 = {
  colspan: "10",
  class: "p-0"
}
const _hoisted_69 = {
  key: 0,
  class: "separator"
}
const _hoisted_70 = { key: 1 }
const _hoisted_71 = {
  colspan: "9",
  class: "dataTables_empty"
}
const _hoisted_72 = { key: 0 }
const _hoisted_73 = {
  key: 0,
  class: "overlay-layer card-rounded bg-dark bg-opacity-5"
}
const _hoisted_74 = /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-primary",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...")
], -1)
const _hoisted_75 = [
  _hoisted_74
]
const _hoisted_76 = { class: "modal-footer flex-right max-sm-justify-content-center" }
const _hoisted_77 = ["disabled"]
const _hoisted_78 = { class: "indicator-label" }
const _hoisted_79 = { class: "svg-icon svg-icon-3 me-2 ms-0" }
const _hoisted_80 = { class: "indicator-progress" }
const _hoisted_81 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_product_info = _resolveComponent("product-info")!
  const _component_sku_info = _resolveComponent("sku-info")!
  const _component_relation_fulfillment = _resolveComponent("relation-fulfillment")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", null, [
                _createElementVNode("h2", _hoisted_7, _toDisplayString(_ctx.t("orderAssign.createMerchantRequest")), 1),
                _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.formData.sku_number) + " SkUs of " + _toDisplayString(_ctx.formData.channel_number) + " merchants ", 1)
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("span", _hoisted_11, [
                    _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_el_select, {
                class: "w-100",
                ref: "selectMerchant",
                onFocus: _ctx.cancelReadonly,
                "onHook:mounted": _ctx.cancelReadonly,
                onVisibleChange: _ctx.cancelReadonly,
                teleported: false,
                modelValue: _ctx.formData.filterOptions.merchant,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.filterOptions.merchant) = $event)),
                filterable: "",
                clearable: "",
                placeholder: _ctx.t('order.merchant'),
                onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.getSalesChannelsData($event, true))),
                disabled: _ctx.loading
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formData.merchant, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.value,
                      label: item.label,
                      value: item.value
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["onFocus", "onHook:mounted", "onVisibleChange", "modelValue", "placeholder", "disabled"]),
              _createVNode(_component_el_select, {
                class: "w-100",
                modelValue: _ctx.formData.filterOptions.channel,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.filterOptions.channel) = $event)),
                multiple: "",
                clearable: "",
                placeholder: _ctx.t('order.channel'),
                disabled: _ctx.loading,
                onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.getSalesChannelsData($event, false)))
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formData.channel, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.value,
                      label: item.label,
                      value: item.value
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "placeholder", "disabled"])
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("span", _hoisted_14, [
              _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createVNode(_component_el_form, {
            onSubmit: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
            model: _ctx.formData,
            rules: _ctx.rules,
            ref: "formRef"
          }, {
            default: _withCtx(() => [
              _withDirectives(_createVNode(_component_el_form_item, { prop: "ids" }, null, 512), [
                [_vShow, false]
              ]),
              _withDirectives(_createVNode(_component_el_form_item, { prop: "channel_list" }, null, 512), [
                [_vShow, false]
              ]),
              _withDirectives(_createVNode(_component_el_form_item, { prop: "fulfilled_list" }, null, 512), [
                [_vShow, false]
              ]),
              _withDirectives(_createVNode(_component_el_form_item, { prop: "rule_list" }, null, 512), [
                [_vShow, false]
              ]),
              _withDirectives(_createVNode(_component_el_form_item, { prop: "items" }, null, 512), [
                [_vShow, false]
              ]),
              _withDirectives(_createVNode(_component_el_form_item, { prop: "filterOptions.channel" }, null, 512), [
                [_vShow, false]
              ]),
              _withDirectives(_createVNode(_component_el_form_item, { prop: "filterOptions.merchant" }, null, 512), [
                [_vShow, false]
              ]),
              _withDirectives(_createVNode(_component_el_form_item, { prop: "channelOption" }, null, 512), [
                [_vShow, false]
              ]),
              _withDirectives(_createVNode(_component_el_form_item, { prop: "channel" }, null, 512), [
                [_vShow, false]
              ]),
              _withDirectives(_createVNode(_component_el_form_item, { prop: "merchant" }, null, 512), [
                [_vShow, false]
              ]),
              _withDirectives(_createVNode(_component_el_form_item, { prop: "itemIndex" }, null, 512), [
                [_vShow, false]
              ]),
              _withDirectives(_createVNode(_component_el_form_item, { prop: "subIndex" }, null, 512), [
                [_vShow, false]
              ]),
              _withDirectives(_createVNode(_component_el_form_item, { prop: "subQuantity" }, null, 512), [
                [_vShow, false]
              ]),
              _withDirectives(_createVNode(_component_el_form_item, { prop: "subMaxQuantity" }, null, 512), [
                [_vShow, false]
              ]),
              _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("table", _hoisted_20, [
                        _createElementVNode("tbody", _hoisted_21, [
                          (_ctx.formData.items.length)
                            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.formData.items, (item, index) => {
                                return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                                  _createElementVNode("tr", _hoisted_22, [
                                    _createElementVNode("td", _hoisted_23, [
                                      _createElementVNode("div", _hoisted_24, [
                                        _createElementVNode("label", {
                                          class: _normalizeClass(["form-check form-check-sm form-check-custom form-check-solid", {
                                      'cursor-nodrop': _ctx.loading,
                                    }]),
                                          onClick: _withModifiers(($event: any) => (_ctx.toggleItemSelect(item)), ["stop"])
                                        }, [
                                          _withDirectives(_createElementVNode("input", {
                                            class: "form-check-input",
                                            type: "checkbox",
                                            "onUpdate:modelValue": ($event: any) => ((item.isChecked) = $event),
                                            disabled: _ctx.loading
                                          }, null, 8, _hoisted_26), [
                                            [_vModelCheckbox, item.isChecked]
                                          ])
                                        ], 10, _hoisted_25)
                                      ])
                                    ]),
                                    _createElementVNode("td", _hoisted_27, [
                                      _createVNode(_component_el_popover, {
                                        placement: "top-start",
                                        width: "auto",
                                        trigger: "hover"
                                      }, {
                                        reference: _withCtx(() => [
                                          _createElementVNode("div", _hoisted_28, [
                                            _createElementVNode("div", _hoisted_29, _toDisplayString(item.channel_name), 1),
                                            _createElementVNode("span", _hoisted_30, _toDisplayString(item.channel_type), 1)
                                          ])
                                        ]),
                                        default: _withCtx(() => [
                                          _createElementVNode("div", null, _toDisplayString(item.merchant_name), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _createElementVNode("td", _hoisted_31, [
                                      _createElementVNode("div", _hoisted_32, [
                                        _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.t("order.qty")), 1),
                                        (item.pcsErrorRule.length > 0)
                                          ? (_openBlock(), _createBlock(_component_el_popover, {
                                              key: 0,
                                              placement: "top",
                                              width: "auto",
                                              trigger: "hover"
                                            }, {
                                              reference: _withCtx(() => [
                                                _createElementVNode("span", _hoisted_34, _toDisplayString(item.selectedQty), 1)
                                              ]),
                                              default: _withCtx(() => [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.pcsErrorRule, (rule, index) => {
                                                  return (_openBlock(), _createElementBlock("p", {
                                                    key: index,
                                                    class: "m-0"
                                                  }, _toDisplayString(_ctx.t("orderAssign.allPcsLimitTip", [
                                          _ctx.getDuration(rule?.duration),
                                          parseInt(rule?.value),
                                        ])), 1))
                                                }), 128))
                                              ]),
                                              _: 2
                                            }, 1024))
                                          : (_openBlock(), _createElementBlock("span", _hoisted_35, _toDisplayString(item.selectedQty), 1))
                                      ])
                                    ]),
                                    _createElementVNode("td", _hoisted_36, [
                                      _createElementVNode("div", _hoisted_37, [
                                        _createElementVNode("div", _hoisted_38, _toDisplayString(_ctx.t("order.grandTotalBase")), 1),
                                        (
                                      item.totalAmountErrorRule.length > 0 ||
                                      item.orderMinAmountErrorRule
                                    )
                                          ? (_openBlock(), _createBlock(_component_el_popover, {
                                              key: 0,
                                              placement: "top",
                                              width: "auto",
                                              trigger: "hover"
                                            }, {
                                              reference: _withCtx(() => [
                                                _createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.$currency.currency(
                                            item.selectedSubtotal,
                                            2,
                                            ",",
                                            ".",
                                            "€ "
                                          )), 1)
                                              ]),
                                              default: _withCtx(() => [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.totalAmountErrorRule, (rule, index) => {
                                                  return (_openBlock(), _createElementBlock("p", {
                                                    key: index,
                                                    class: "m-0"
                                                  }, _toDisplayString(_ctx.t("orderAssign.allAmountLimitTip", [
                                          _ctx.getDuration(rule?.duration),
                                          _ctx.$currency.currency(
                                            rule?.value,
                                            2,
                                            ",",
                                            ".",
                                            "€ "
                                          ),
                                        ])), 1))
                                                }), 128)),
                                                (item.orderMinAmountErrorRule)
                                                  ? (_openBlock(), _createElementBlock("p", _hoisted_39, _toDisplayString(_ctx.t("orderAssign.allMinAmountLimitTip", [
                                          _ctx.getDuration(
                                            item.orderMinAmountErrorRule
                                              ?.duration
                                          ),
                                          _ctx.$currency.currency(
                                            item.orderMinAmountErrorRule?.value,
                                            2,
                                            ",",
                                            ".",
                                            "€ "
                                          ),
                                        ])), 1))
                                                  : _createCommentVNode("", true)
                                              ]),
                                              _: 2
                                            }, 1024))
                                          : (_openBlock(), _createElementBlock("span", _hoisted_41, _toDisplayString(_ctx.$currency.currency(
                                        item.selectedSubtotal,
                                        2,
                                        ",",
                                        ".",
                                        "€ "
                                      )), 1))
                                      ])
                                    ]),
                                    _createElementVNode("td", _hoisted_42, [
                                      _createElementVNode("button", {
                                        type: "button",
                                        class: _normalizeClass(["btn btn-icon toggle-btn btn-bg-light btn-active-color-primary btn-sm", { active: item.isExpand }]),
                                        onClick: ($event: any) => (_ctx.expandSub(item))
                                      }, [
                                        _createElementVNode("span", _hoisted_44, [
                                          _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr075.svg" })
                                        ]),
                                        _createElementVNode("span", _hoisted_45, [
                                          _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr090.svg" })
                                        ])
                                      ], 10, _hoisted_43)
                                    ])
                                  ]),
                                  (item.items.length)
                                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(item.items, (row, rowIndex) => {
                                        return _withDirectives((_openBlock(), _createElementBlock("tr", {
                                          class: _normalizeClass(["subtable_template order-assign-merchant-order-list text-start border-dashed", {
                                  'border-0':
                                    rowIndex === item.items.length - 1,
                                }]),
                                          key: rowIndex
                                        }, [
                                          _createElementVNode("td", _hoisted_46, [
                                            _createElementVNode("div", _hoisted_47, [
                                              _createElementVNode("label", {
                                                class: _normalizeClass(["form-check form-check-sm form-check-custom form-check-solid", {
                                        'cursor-nodrop': _ctx.loading,
                                      }]),
                                                onClick: _withModifiers(($event: any) => (_ctx.toggleSubSelect(item, row)), ["stop"])
                                              }, [
                                                _withDirectives(_createElementVNode("input", {
                                                  class: "form-check-input",
                                                  type: "checkbox",
                                                  "onUpdate:modelValue": ($event: any) => ((row.isChecked) = $event),
                                                  disabled: _ctx.loading
                                                }, null, 8, _hoisted_49), [
                                                  [_vModelCheckbox, row.isChecked]
                                                ])
                                              ], 10, _hoisted_48)
                                            ])
                                          ]),
                                          _createElementVNode("td", _hoisted_50, [
                                            _createVNode(_component_product_info, {
                                              gallery: [
                                      {
                                        id: 0,
                                        origin_url: row.product_gallery,
                                      },
                                    ],
                                              name: row.product_name,
                                              name_en: row.product_name,
                                              source_link: '',
                                              brand_id: row.brand_name
                                            }, null, 8, ["gallery", "name", "name_en", "brand_id"])
                                          ]),
                                          _createElementVNode("td", _hoisted_51, [
                                            _createElementVNode("div", _hoisted_52, [
                                              _createVNode(_component_sku_info, {
                                                brand_article_no: row.article_no,
                                                color: row.color,
                                                size: row.size,
                                                product_identifier_id: '0'
                                              }, null, 8, ["brand_article_no", "color", "size"]),
                                              (row.relation_fulfillment)
                                                ? (_openBlock(), _createBlock(_component_el_popover, {
                                                    key: 0,
                                                    placement: "top",
                                                    width: "auto",
                                                    trigger: "click"
                                                  }, {
                                                    reference: _withCtx(() => [
                                                      _createElementVNode("span", _hoisted_53, [
                                                        _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen044.svg" })
                                                      ])
                                                    ]),
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_relation_fulfillment, {
                                                        items: row.relation_fulfillment,
                                                        isShowSubPosition: false,
                                                        isShowOldFulfillmentId: false
                                                      }, null, 8, ["items"])
                                                    ]),
                                                    _: 2
                                                  }, 1024))
                                                : _createCommentVNode("", true)
                                            ])
                                          ]),
                                          _createElementVNode("td", _hoisted_54, [
                                            _createElementVNode("div", _hoisted_55, [
                                              _createElementVNode("div", _hoisted_56, _toDisplayString(_ctx.t("order.qty")), 1),
                                              _createElementVNode("div", _hoisted_57, [
                                                _createVNode(_component_el_input_number, {
                                                  modelValue: row.qty,
                                                  "onUpdate:modelValue": ($event: any) => ((row.qty) = $event),
                                                  min: 1,
                                                  max: row.max_qty,
                                                  size: "small",
                                                  onChange: _ctx.handleQtyChange
                                                }, null, 8, ["modelValue", "onUpdate:modelValue", "max", "onChange"]),
                                                (
                                          _ctx.skuItemPcsHasError(
                                            row,
                                            row.pcsErrorRule,
                                            row.skuPcsErrorRule,
                                            row.orderSkuPcsErrorRule,
                                            item.brandPcsErrorRule,
                                            item.categoryPcsErrorRule,
                                            item.skuPcsErrorRule,
                                            item.brandSkuPcsErrorRule,
                                            item.categorySkuPcsErrorRule,
                                            item.orderSkuPcsErrorRule,
                                            item.brandOrderSkuPcsErrorRule,
                                            item.categoryOrderSkuPcsErrorRule
                                          )
                                        )
                                                  ? (_openBlock(), _createBlock(_component_el_popover, {
                                                      key: 0,
                                                      placement: "top",
                                                      width: "auto",
                                                      trigger: "hover"
                                                    }, {
                                                      reference: _withCtx(() => [
                                                        _createElementVNode("span", _hoisted_59, [
                                                          _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen044.svg" })
                                                        ])
                                                      ]),
                                                      default: _withCtx(() => [
                                                        _createElementVNode("div", {
                                                          innerHTML: 
                                            _ctx.getSkuItemPcsErrorTips(
                                              row,
                                              row.pcsErrorRule,
                                              row.skuPcsErrorRule,
                                              row.orderSkuPcsErrorRule,
                                              item.brandPcsErrorRule,
                                              item.categoryPcsErrorRule,
                                              item.skuPcsErrorRule,
                                              item.brandSkuPcsErrorRule,
                                              item.categorySkuPcsErrorRule,
                                              item.orderSkuPcsErrorRule,
                                              item.brandOrderSkuPcsErrorRule,
                                              item.categoryOrderSkuPcsErrorRule
                                            )
                                          
                                                        }, null, 8, _hoisted_58)
                                                      ]),
                                                      _: 2
                                                    }, 1024))
                                                  : (_openBlock(), _createBlock(_component_el_popover, {
                                                      key: 1,
                                                      placement: "top",
                                                      width: "auto",
                                                      trigger: "hover"
                                                    }, {
                                                      reference: _withCtx(() => [
                                                        _createElementVNode("span", _hoisted_60, [
                                                          _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen044.svg" })
                                                        ])
                                                      ]),
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_ctx.t("orderAssign.qtyTip")) + " ", 1)
                                                      ]),
                                                      _: 1
                                                    }))
                                              ])
                                            ])
                                          ]),
                                          _createElementVNode("td", _hoisted_61, [
                                            _createElementVNode("div", _hoisted_62, [
                                              _createElementVNode("div", _hoisted_63, _toDisplayString(_ctx.t("order.grandTotalBase")), 1),
                                              (
                                        _ctx.skuItemAmountHasError(
                                          row,
                                          row.amountErrorRule,
                                          row.minAmountErrorRule,
                                          item.brandAmountErrorRule,
                                          item.categoryAmountErrorRule,
                                          item.brandMinAmountErrorRule,
                                          item.categoryMinAmountErrorRule
                                        )
                                      )
                                                ? (_openBlock(), _createBlock(_component_el_popover, {
                                                    key: 0,
                                                    placement: "top",
                                                    width: "auto",
                                                    trigger: "hover"
                                                  }, {
                                                    reference: _withCtx(() => [
                                                      _createElementVNode("span", _hoisted_65, _toDisplayString(_ctx.$currency.currency(
                                              row.qty *
                                                Number(row.original_price),
                                              2,
                                              ",",
                                              ".",
                                              "€ "
                                            )), 1)
                                                    ]),
                                                    default: _withCtx(() => [
                                                      _createElementVNode("div", {
                                                        innerHTML: 
                                          _ctx.getSkuItemAmountErrorTips(
                                            row,
                                            row.amountErrorRule,
                                            row.minAmountErrorRule,
                                            item.brandAmountErrorRule,
                                            item.categoryAmountErrorRule,
                                            item.brandMinAmountErrorRule,
                                            item.categoryMinAmountErrorRule
                                          )
                                        
                                                      }, null, 8, _hoisted_64)
                                                    ]),
                                                    _: 2
                                                  }, 1024))
                                                : (_openBlock(), _createElementBlock("span", _hoisted_66, _toDisplayString(_ctx.$currency.currency(
                                          row.qty * Number(row.original_price),
                                          2,
                                          ",",
                                          ".",
                                          "€ "
                                        )), 1))
                                            ])
                                          ]),
                                          _hoisted_67
                                        ], 2)), [
                                          [_vShow, item.isExpand]
                                        ])
                                      }), 128))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("tr", null, [
                                    _createElementVNode("td", _hoisted_68, [
                                      (index != _ctx.formData.items.length - 1)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_69))
                                        : _createCommentVNode("", true)
                                    ])
                                  ])
                                ], 64))
                              }), 128))
                            : (_openBlock(), _createElementBlock("tr", _hoisted_70, [
                                _createElementVNode("td", _hoisted_71, [
                                  _createElementVNode("p", null, [
                                    (!_ctx.loading)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_72, "No data found"))
                                      : _createCommentVNode("", true)
                                  ])
                                ])
                              ]))
                        ])
                      ])
                    ]),
                    (_ctx.loading)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_73, _hoisted_75))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])), [
                [_directive_loading, _ctx.loading]
              ]),
              _createElementVNode("div", _hoisted_76, [
                _createElementVNode("button", {
                  ref: "submitButton",
                  type: "submit",
                  class: "btn btn-lg btn-primary",
                  disabled: _ctx.isDisabledSubmit
                }, [
                  _createElementVNode("span", _hoisted_78, [
                    _createElementVNode("span", _hoisted_79, [
                      _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr064.svg" })
                    ]),
                    _createTextVNode(" " + _toDisplayString(_ctx.t("common.submit")), 1)
                  ]),
                  _createElementVNode("span", _hoisted_80, [
                    _createTextVNode(_toDisplayString(_ctx.t("common.pleaseWait")) + " ", 1),
                    _hoisted_81
                  ])
                ], 8, _hoisted_77)
              ])
            ]),
            _: 1
          }, 8, ["model", "rules"])
        ])
      ])
    ])
  ], 512))
}